import React from 'react'
import { connect } from 'react-redux'
import {
  loadPlanEntries,
  changeOrder,
  setInitialFilters,
  clearPlanEntries,
  setDefaultFilter
} from '../../../redux/actions/planEntries'
import PropTypes from 'prop-types'
import { planEntries } from '../../../redux/selectors/planEntries'
import ClassFinderContent from './ClassFinderContent'
import {
  convertFilterByFieldToObject,
  createFilteredStylesObj
} from './classFinderHelperMethods'
import { insertPlanCategories } from '../../../redux/actions/planCategories'

class ClassFinderDataLoader extends React.Component {
  componentDidMount() {
    if (this.props.defaultValue) {
      this.props.setDefaultFilter({
        instructors: this.props.preloadedFilters.instructors || []
      })
    }
    let stylesFilterObj = createFilteredStylesObj(
      this.props.dropdownOptions.styles,
      this.props.preloadedFilters.styles
    )
    let individualStylesObj = {}
    for (const individualFilter in stylesFilterObj) {
      individualStylesObj[individualFilter] =
        stylesFilterObj[individualFilter].filteredSubcategories
    }

    const preFilters = {
      duration: this.props.preloadedFilters.duration,
      instructors: convertFilterByFieldToObject(
        this.props.dropdownOptions.instructors || [],
        'slug',
        this.props.preloadedFilters.instructors
      ),
      difficulties: this.props.preloadedFilters.difficulties,
      intensities: convertFilterByFieldToObject(
        this.props.dropdownOptions.intensities,
        'level',
        this.props.preloadedFilters.intensities
      ),
      equipment: this.props.preloadedFilters.equipment,
      focus_area: this.props.preloadedFilters.focus_area,
      excludeCompleted: this.props.preloadedFilters.excludeCompleted,
      styles: {},
      ...individualStylesObj
    }
    this.props.insertPlanCategories(this.props.dropdownOptions.styles)
    this.props.setInitialFilters(preFilters)
    this.props.changeOrder(this.props.defaultOrder || 'relevance')
    this.props.clearPlanEntries()
    this.props.loadPlanEntries(() => {
      window.history.replaceState(
        this.props.filteredAttributes,
        null,
        `${this.props.baseUrl}?${this.props.filterUrl}`
      )
    })
  }

  render() {
    return (
      <React.Fragment>
        <ClassFinderContent
          withSubcategories={this.props.withSubcategories}
          autopaginate={this.props.autopaginate}
          includeFilters={this.props.includeFilters}
          planEntries={this.props.planEntries}
          preloadedFilters={this.props.preloadedFilters}
          baseUrl={this.props.baseUrl}
          dropdownOptions={this.props.dropdownOptions}
        />
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    planEntries: planEntries(state),
    filteredAttributes: state.ui.planEntries.filtered,
    filterUrl: state.ui.planEntries.filterUrl
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadPlanEntries: (callback) => {
      dispatch(loadPlanEntries(callback))
    },
    setInitialFilters: (filters) => {
      dispatch(setInitialFilters(filters))
    },
    changeOrder: (order) => {
      dispatch(changeOrder(order))
    },
    insertPlanCategories: (categories) => {
      dispatch(insertPlanCategories(categories))
    },
    clearPlanEntries: () => {
      dispatch(clearPlanEntries())
    },
    setDefaultFilter: (value) => {
      dispatch(setDefaultFilter(value))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassFinderDataLoader)

ClassFinderDataLoader.defaultProps = {
  defaultOrder: 'relevance'
}

ClassFinderDataLoader.propTypes = {
  autopaginate: PropTypes.bool,
  baseUrl: PropTypes.string,
  categoryFilterOptions: PropTypes.array,
  setInitialFilters: PropTypes.func,
  changeOrder: PropTypes.func,
  defaultOrder: PropTypes.string,
  preloadedFilters: PropTypes.object,
  instructorFilterOptions: PropTypes.array,
  includeFilters: PropTypes.bool,
  planEntries: PropTypes.array,
  loadPlanEntries: PropTypes.func,
  filteredAttributes: PropTypes.object,
  filterUrl: PropTypes.string,
  insertPlanCategories: PropTypes.func,
  withSubcategories: PropTypes.bool,
  dropdownOptions: PropTypes.object,
  clearPlanEntries: PropTypes.func
}
